import { useDispatch } from '../context/store';

export default function useGetTaxonomies() {
	const dispatch = useDispatch();

	const getRequestUrl = function () {
		const url = `${WP.siteUrl}/wp-json/trip-finder/get-taxonomies?`;

		return url;
	};

	const getTaxonomies = async function () {
		const url = getRequestUrl();
		const response = await fetch(url);
		const data = await response.json();
		// console.log(data, 'taxes');

		dispatch({ type: 'setTaxonomies', payload: data });
	};

	return {
		getTaxonomies,
	};
}
